<div class="center-header-info">
  <div class="context-column">
    <h3 class="consumer-info">
      {{ selectedConsumer?.name | titlecase }}
    </h3>
    @if (selectedConsumer && selectedLocation) {
      <h4 class="context-info">
        {{ selectedLocation.tag | titlecase }} - {{ selectedLocation.name | titlecase }}
      </h4>
    }
  </div>
  @if (selectedConsumer && selectedLocation) {
    <div class="search-column">
      <emm-menu-search
        (clearSearchButtonClicked)="handleClearSearchButtonClicked()"
        (searchButtonClicked)="handleSearchButtonClicked($event)"
      ></emm-menu-search>
    </div>
  }
</div>
